import React from 'react';
import styled from 'styled-components';

type ContainerProps = {
  darkOverlay?: number
  zIndex?: number
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  
  z-index: ${({ zIndex }: ContainerProps) => zIndex ? zIndex : -1};

  ${({ darkOverlay }: ContainerProps) => {
    if (darkOverlay)
      return`
        .dark-overlay {
          width: 100%;
          height: 100%;
          background-color: black;
          opacity: ${darkOverlay};
        }
      `;
  }}

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

type Props = {
  src: string
  alt: string
  darkOverlay?: number
  zIndex?: number
}

const BgImage = ({ src, alt, darkOverlay, zIndex }: Props) => {
  return (
    <Container darkOverlay={darkOverlay} zIndex={zIndex}>
      
      <img src={src} alt={alt}/>
      <div className='dark-overlay'/>
    </Container>
  );
};

export default BgImage;